import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";

import AthleteSearchPage from "../components/scouting/AthleteSearchPage";
import { useAuth } from "../context/AuthContext";
import { useNotifications } from "../components/layout/routing/AppShell";

const AthleteSearchRoute = () => {
  const navigate = useNavigate();
  const { searchId: searchIdParam } = useParams();
  const searchId = searchIdParam || null;
  const {
    availableAthletes,
    scoutData,
    scoutSearches,
    activeSearchId,
    setActiveSearchId,
  } = useAuth();
  const { openNotifications } = useNotifications();

  useEffect(() => {
    if (searchId && activeSearchId !== searchId) {
      setActiveSearchId(searchId);
    }
  }, [searchId, activeSearchId, setActiveSearchId]);

  return (
    <AthleteSearchPage
      athletes={availableAthletes}
      displayName={scoutData?.full_name || "Scout"}
      searches={scoutSearches}
      activeSearchId={searchId}
      onActiveSearchChange={(nextId) => navigate(`/scout/searches/${nextId}`)}
      onGoToSearches={() => navigate("/scout/searches")}
      onNotificationsClick={openNotifications}
    />
  );
};

export default AthleteSearchRoute;
